import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"


const api = new APIClient();

// Get List
export const getList = () => api.get(url.GET_KNOWLEDGE, null);

// Get Detail
export const getDetail = (id: string) => api.get(`${url.GET_KNOWLEDGE}/${id}`, null);

// Create Knowledge
export const create = (payload: any) => api.create(url.CREATE_KNOWLEDGE, payload);

// Update Knowledge
export const update = (id: string, payload: any) => api.put(`${url.UPDATE_KNOWLEDGE}/${id}`, payload);

// Delete Knowledge
export const remove = (id: string) => api.delete(`${url.DELETE_KNOWLEDGE}/${id}`, null);

export const initializeKnowledgeBase = (payload: any) => api.create(url.INITIALIZE_KNOWLEDGE_BASE, payload);

export const addDocument = (knowledgeId: string | null, payload: any) => api.put(`${url.CREATE_KNOWLEDGE}/${knowledgeId}/document/create`, payload);

export const getDocument = (id: string) => {
  return api.get(`${url.GET_DOCUMENT}/${id}`, null);
};

// Upload File
export const uploadFileData = (source: string, file: File): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);
  return api.create(`${url.UPLOAD_FILE}?source=${source}`, formData);
};

// Crawl Website
export const crawlWebsite = (payload: any) => {
  const response = api.create(url.CRAWL_WEBSITE, payload);
  return response;
};

export const deleteDocuments = (id: string, payload: any[]) => {
  return api.create(`${url.DELETE_KNOWLEDGE}/${id}/documents`, payload);
};

export const deleteSegments = (knowledgeId: string, documentId: string, payload: any[]) => {
  return api.create(`${url.DELETE_KNOWLEDGE}/${knowledgeId}/documents/${documentId}/segments`, payload);
};

export const updateSegments = (knowledgeId: string, documentId: string, segmentId: string, payload: any[]) => {
  return api.put(`${url.UPDATE_KNOWLEDGE}/${knowledgeId}/documents/${documentId}/segments/${segmentId}`, payload);
};

export const addSegment = (knowledgeId: string, documentId: string, payload: any) => {
  return api.create(`${url.CREATE_KNOWLEDGE}/${knowledgeId}/documents/${documentId}/segments/create`, payload);
};

export const searchRAG = (payload: any): Promise<any> => {
  return api.create(`${url.SEARCH_RAG}`, payload);
};

